import { render, staticRenderFns } from "./StatisticEntryView.vue?vue&type=template&id=35fe6a70&"
import script from "./StatisticEntryView.vue?vue&type=script&lang=ts&"
export * from "./StatisticEntryView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports